<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddDrawer"
          >新 增
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          v-if="permission.inspecttask_view"
          @click="openInspecttaskViewDialog(scope.row)"
          >任务明细
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-close"
          v-if="permission.inspectplan_delete"
          :hidden="hideApplyBtn(scope.row)"
          @click="rowDel(scope.row)"
          >关闭
        </el-button>
      </template>
    </avue-crud>
    <el-drawer
      :visible.sync="openAddDrawerFlag"
      :modal-append-to-body="false"
      @close="quitAddDrawer"
      size="70%"
    >
      <div class="el-dialog-div">
        <avue-form ref="addFormRef" v-model="addForm" :option="addOption" @submit="addSubmit">
          <template slot="crud1" slot-scope="scope">
            <avue-crud
              ref="crud2"
              :data="data1Copy"
              :option="option2"
              @selection-change="selectionChangeItem"
            >
              <template slot="menuLeft">
                <el-input
                  v-model="inspectContent"
                  @input="inspectContentFilter()"
                  placeholder="模糊匹配巡检内容"
                >
                </el-input>
              </template>
            </avue-crud>
          </template>
          <template slot="crud1Label" slot-scope="row">
            <span><span style="color: red;">*&nbsp;</span>巡检项:&nbsp;&nbsp;</span>
          </template>
          <template slot="time" slot-scope="row">
            <select-time @getTime="getTime" ref="selectTime"> </select-time>
          </template>
          <template slot="timeLabel" slot-scope="row">
            <span><span style="color: red;">*&nbsp;</span>时间段:&nbsp;&nbsp;</span>
          </template>

          <template slot-scope="scope" slot="areaId">
            <el-select
              @change="selectBasePropertyChange"
              v-model="addForm.areaId"
              filterable
              clearable
            >
              <el-option
                v-for="item in basePropertyList"
                :key="item.id"
                :label="item.objectFullName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope" slot="groupId">
            <el-select v-model="addForm.groupId" filterable clearable>
              <el-option
                v-for="item in inspectGroupList"
                :key="item.id"
                :label="item.groupName"
                :value="item.id"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="item.rightValue"
                  placement="top-start"
                >
                  <span style="float: left;">{{ item.groupName }}</span>
                </el-tooltip>
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope" slot="nodeId">
            <el-select
              v-model="addForm.nodeId"
              @change="nodeIdChange"
              filterable
              multiple
              clearable
            >
              <el-option
                v-for="item in inspectNodeList"
                :key="item.id"
                :label="item.nodeName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitAddDrawer">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-drawer>
  </basic-container>
</template>

<script>
    import {checkPath} from '@/api/user'
import {
  add,
  getDetail,
  getList,
  submitTemporaryType,
  update,
  updateTaskStatus,
} from '@/api/v4ward/inspecttask/inspecttask';
import { mapGetters } from 'vuex';
import inspecttaskAddOption from './inspecttask-add-option';
import { getInspectProject, getBasePropertyTree } from '@/api/v4ward/inspectplan/inspectplan';
import selectTime from '@/components/inspect/select-time.vue';
import { getInspectGroupTree } from '@/api/v4ward/inspectgroup/inspectgroup';
import { getInspectNodeTree } from '@/api/v4ward/inspectnode/inspectnode';
import ElTreeSelect from '@/components/vard-select-tree/vard-select-tree';

var V = (rule, value, callback) => {
  if (value > 60) {
    callback(new Error('逾期时间范围请控制在1-60'));
  } else if (value < 1) {
    callback(new Error('逾期时间范围请控制在1-60'));
  } else {
    callback();
  }
};
export default {
  components: {
    ElTreeSelect,
    'select-time': selectTime,
  },
  data() {
    return {
      basePropertyList: [],
      inspectNodeList: [],
      inspectGroupList: [],
      openAddDrawerFlag: false,
      addOption: inspecttaskAddOption,
      addForm: {},
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        selection: false,
        columnBtn: false,
        refreshBtn: false,
        searchLabelWidth: 100,
        column: [
          {
            label: '主键',
            prop: 'id',
            hide: true,
          },
          {
            label: '任务名称',
            prop: 'inspectPlanName',
            maxlength: 30,
            showWordLimit: true,
            search: true,
            overHidden: true,
            searchPlaceholder: '模糊匹配任务名称',
          },
          {
            label: '班组名称',
            prop: 'groupId',
            hide: true,
            type: 'tree',
            dicUrl: 'api/inspectGroup/inspectGroupTree',
            props: { label: 'groupName', value: 'id' },
            overHidden: true,
          },
          {
            label: '班组名称',
            prop: 'inspectGroupName',
            search: true,
            maxlength: 30,
            showWordLimit: true,
            searchPlaceholder: '模糊匹配班组名称',
          },
          {
            label: '班组负责人',
            prop: 'groupPrincipalId',
            labelWidth: 150,
            span: 8,
            search: true,
            type: 'tree',
            dicUrl: 'api/blade-user/userTree',
            props: { label: 'realName', value: 'id' },
            rules: [
              {
                required: true,
                message: '请选择班组负责人',
                trigger: 'blur',
              },
            ],
          },

          {
            label: '任务类型',
            prop: 'type',
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=type',
            props: { label: 'dictValue', value: 'dictKey' },
            search: true,
          },
          {
            label: '任务日期',
            prop: 'taskTime',
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '巡视开始时间',
            type: 'datetime',
            prop: 'inspectBeginTime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: [
              {
                required: true,
                message: '请输入巡视开始时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '巡视结束时间',
            type: 'datetime',
            prop: 'inspectEndTime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: [
              {
                required: true,
                message: '请输入巡视结束时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '任务状态',
            prop: 'taskStatus',
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=task_status',
            props: { label: 'dictValue', value: 'dictKey' },
            search: true,
          },
          // {
          //   label: '备注',
          //   prop: 'remark',
          //   overHidden: true,
          //   maxlength: 200,
          //   showWordLimit: true,
          // },
          {
            label: '任务日期',
            prop: 'taskTimeRange',
            searchSpan: 8,
            search: true,
            searchRange: true,
            hide: true,
            type: 'daterange',
            display: false,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
        ],
      },
      data: [],
      data1: [],
      data1Copy: [],
      data2: [],
      inspectContent: '',
      option2: {
        page: false,
        border: true,
        addBtn: false,
        selection: true,
        tip: false,
        columnBtn: false,
        refreshBtn: false,
        menuAlign: 'center',
        menu: false,
        column: [
          {
            label: 'ID',
            prop: 'nodeId',
            hide: true,
          },
          {
            label: '巡检点名称',
            prop: 'nodeName',
          },
          {
            label: '巡检点id',
            prop: 'projectId',
            hide: true,
          },
          {
            label: '巡检项',
            prop: 'inspectContent',
          },
        ],
      },
    };
  },
  watch: {
    'addForm.staleDatedStatus': {
      handler(val) {
        this.handlerHide(val);
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.inspecttask_add, false),
        viewBtn: this.vaildData(this.permission.inspecttask_view, false),
        delBtn: this.vaildData(this.permission.inspecttask_delete, false),
        editBtn: this.vaildData(this.permission.inspecttask_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.initAllList();
  },
  methods: {
    nodeIdChange(value) {
      if (value) {
        this.addForm.nodeId = value;
        this.data1 = [];
        if (this.addForm.nodeId.length !== 0) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          });
          getInspectProject(this.addForm.nodeId.join(',')).then(({ data }) => {
            this.data1 = data;
            this.data1Copy = data;
            loading.close();
          });
        }
      } else {
        this.data1 = [];
        this.data1Copy = [];
      }
    },
    selectBasePropertyChange(value) {
      getInspectGroupTree(value).then(({ data }) => {
        this.inspectGroupList = data;
      });
      getInspectNodeTree(value).then(({ data }) => {
        this.inspectNodeList = data;
      });
    },
    initAllList() {
      getInspectGroupTree().then(({ data }) => {
        this.inspectGroupList = data;
      });
      getInspectNodeTree().then(({ data }) => {
        this.inspectNodeList = data;
      });
      getBasePropertyTree().then(({ data }) => {
        this.basePropertyList = data;
      });
    },
    // 获得时间选择器传来的值
    getTime(time) {
      this.addForm.timeQuantum = time;
    },
    inspectContentFilter() {
      console.log(this.inspectContent);
      let inspectContent = this.inspectContent;
      if (inspectContent) {
        this.data1Copy = this.data1.filter(function (item) {
          return item.inspectContent.indexOf(inspectContent) > -1;
        });
      } else {
        this.data1Copy = this.data1;
      }
    },
    hideApplyBtn(row) {
      //    --》隐藏【巡检记录】按钮
      return row.taskStatus === 1 || row.taskStatus === 3 || row.taskStatus === 2;
    },
    selectionChangeItem(list) {
      this.addForm.projects = list;
    },
    openInspecttaskViewDialog(row) {
      if (document.querySelector('div[id*="tab-/inspecttasklist/inspecttasklist"]>span')) {
        document.querySelector('div[id*="tab-/inspecttasklist/inspecttasklist"]>span').click();
      }
                checkPath({
                    path:'/crmedical/warehouse/supplies-recipients/outbound-record/outbound-record'
                }).then(({data})=>{
                    if(data.data){
                      this.$router.push({ path: '/inspecttasklist?taskId=' + row.id });
                    }else{
                        this.$message.error('您无浏览此页面的权限！');
                    }
                })
    },
    handlerHide(val) {
      var beyondTheTime = this.findObject(this.addOption.group[0].column, 'beyondTheTime');
      if (val === 0) {
        beyondTheTime.display = true;
        beyondTheTime.rules = [
          { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入正整数' },
          {
            required: true,
            message: '请输入超期时间(分钟)',
            trigger: 'change',
          },
          {
            validator: V,
            message: '逾期时间范围请控制在1-60分钟',
            trigger: 'blur',
          },
        ];
      } else {
        beyondTheTime.display = false;
        beyondTheTime.rules = [];
      }
    },
    openAddDrawer() {
      this.addForm.type = 1;
      var date = new Date();
      this.addForm.taskTime =
        date.getFullYear() +
        '-' +
        (date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)) +
        '-' +
        (date.getDate() > 10 ? date.getDate() : '0' + date.getDate());
      this.openAddDrawerFlag = true;
    },
    quitAddDrawer() {
      this.openAddDrawerFlag = false;
      this.addForm.timeQuantum = ''; //时间段
      this.addForm.planName = ''; //任务名称
      this.addForm.areaId = ''; //小区
      this.addForm.groupId = ''; //班组
      this.addForm.nodeId = ''; //巡检点名称
      this.addForm.staleDatedStatus = 1; //允许超期
      this.addForm.beyondTheTime = ''; //超期时间
      this.inspectContent = '';
      this.data1 = [];
      this.data2 = [];
      this.data1Copy = [];
      setTimeout(() => {
        this.$refs.selectTime.reset();
      }, 0);
    },
    addSubmit(form, done) {
      if (!form.timeQuantum) {
        this.$message.error('请至少选择一个时间段');
        done();
        return;
      }
      if (this.addForm.projects.length === 0) {
        this.$message.error('请配置巡检项');
        done();
        return;
      }
      //校验每个巡检点必须勾选一个巡检项
      var nodeIds = form.nodeId;
      let a = '';
      this.addForm.projects.forEach((val) => {
        a += val.nodeId + ',';
      });
      let b = '';
      for (let i = 0; i < nodeIds.length; i++) {
        if (a.indexOf(nodeIds[i]) > -1) {
          b += '0';
        } else {
          b += '1';
        }
      }
      console.log(b);
      if (b.indexOf('1') > -1) {
        this.$message.error('每个巡检点请至少选择一个巡检项');
        done();
        return;
      }
      form.taskTime = form.taskTime + ' 00:00:00';
      let time = [];
      form.timeQuantum.forEach((s) => {
        time.push(s.time);
      });
      form.timeQuantum = time.join(',');
      form.nodeId = form.nodeId.join(',');
      submitTemporaryType(form).then(
        () => {
          done();
          this.quitAddDrawer();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据关闭?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return updateTaskStatus({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return updateTaskStatus({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if (this.query.taskTimeRange) {
        this.query.taskTimeStart = this.query.taskTimeRange[0];
        this.query.taskTimeEnd = this.query.taskTimeRange[1];
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style scoped>
/deep/ .el-drawer__body {
  overflow: scroll !important;
}
</style>
